import React, { FC } from 'react';
import { swatchCss } from 'src/components/ProductDetail/utils/swatchData';
import classnames from 'classnames';
import { Checkbox } from 'src/core/forms';

import { SwatchOption } from '../Swatch/SwatchOption';

import { Swatch } from './ProductSwatch';
import classes from './ProductSwatch.scss';

type Props = {
    swatches: Swatch[];
    showMore?: boolean;
    selectedSwatchesId?: number[];
    onSet: (Swatch: Swatch) => void;
    isSwatchDisabled: (colorId: number) => void;
    bundleIndex: number;
};
export const ProductSwatchColors: FC<Props> = ({
    swatches,
    showMore,
    onSet,
    isSwatchDisabled,
    selectedSwatchesId,
    bundleIndex,
}) => {
    return (
        <div className={classes.swatchContainer}>
            {swatches.map((swatch, index) => {
                const css = swatchCss(swatch.swatch_data);
                return (
                    <SwatchOption
                        key={swatch.value_index}
                        optionName={swatch.title}
                        htmlFor={`swatch-${bundleIndex}-${swatch.value_index}`}
                        labelClassName={classnames(classes.swatchesItemLabel, {
                            [classes.swatchesItemHide]: showMore && index,
                            [classes.swatchesItemDisable]: isSwatchDisabled(swatch.value_index),
                        })}
                        input={
                            <Checkbox
                                field={`colours.index:${swatch.value_index}`}
                                id={`swatch-${bundleIndex}-${swatch.value_index}`}
                                value={swatch.value_index}
                                data-value={swatch.title}
                                className={classes.swatchesItemInput}
                                onClick={() => onSet(swatch)}
                                checked={selectedSwatchesId && selectedSwatchesId.includes(swatch.value_index)}
                            />
                        }
                    >
                        <span className={classes.swatchesItem} style={css} data-value={swatch.title}>
                            <img src={require('../../../static/icons/ok.png')} alt="" data-img="img-one" />
                            <img src={require('../../../static/icons/cancel.png')} alt="" data-img="img-two" />
                        </span>
                    </SwatchOption>
                );
            })}
        </div>
    );
};
